var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76 8V10.75H1H0.75V11V13V13.25H1H7.76V16V16.6046L8.187 16.1766L12.177 12.1766L12.3531 12L12.177 11.8234L8.187 7.82344L7.76 7.39538V8ZM13.813 10.1766L14.24 10.6046V10V7.25H21H21.25V7V5V4.75H21H14.24V2V1.39538L13.813 1.82344L9.823 5.82344L9.64689 6L9.823 6.17656L13.813 10.1766Z",
    fill: "#81909E",
    stroke: "#81909E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.e797c28e3a60e9fa6e19979666018913.svg";
export { ForwardRef as ReactComponent };